module.exports = __webpack_public_path__ + "img/icon-simplicidade.8953965d.png";